// extracted by mini-css-extract-plugin
export default {"wrapper":"burger_wrapper__QIrUr","container":"burger_container__sJGiA","active":"burger_active__Nm5Pe"};